import { useTranslation } from "react-i18next";
import image from '../../img/TradeTerminal/deposit.png';
import imagemob from '../../img/TradeTerminal/depositmob.png';

const Deposit = () => {
    const { t } = useTranslation();
    return (
        <section className="open-sans relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto relative">
                <div className="relative overflow-hidden bg-[#FFF] sm:rounded-[20px] lg:px-[65px] md:px-[40px] lg:py-[55px] pt-[40px] pb-0">
                    <div className="relative z-10 md:w-[525px] px-[20px] md:px-0">
                        <h2 className="text-[#0C2780] font-[700] text-[28px]">
                            {t('terminal.deposit.title')}
                        </h2>
                        <p className="mt-[25px] md:mt-[30px] sm:text-[16px] text-[14px] text-[#0C2780] font-[600]">
                            {t('terminal.deposit.subtitle')}
                        </p>
                        <p className="mt-[13px] md:mt-[15px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                            {t('terminal.deposit.text')}
                        </p>
                    </div>
                    <img className="lg:absolute relative z-0 h-[100%] hidden bottom-0 lg:right-[0] md:right-[-40px] right-[-20px] sm:flex ml-auto mt-[30px] lg:mt-0" src={image} alt='' />
                    <img src={imagemob} className="relative sm:hidden mt-[8px] mb-[-2px]" alt="" />
                </div>
            </div>
        </section>
    )
};

export default Deposit;
